import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-owf_sign_up_flow_upsell_skip-click';

/**
 * Track the "skip" click action when a user sees the OWF upsell in the sign-up flow. Skipping signifies skipping the application form.
 */
export function trackOpenWithFaireOwfSignUpFlowUpsellSkipClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
